import React, { FC, useCallback } from 'react'
import clsx from 'clsx'
import { Grid, TextField, InputAdornment } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles, withStyles } from '@mui/styles'

import { useFormContext } from 'react-hook-form'
import { icons } from '../../constants/icons'

const useStyle = makeStyles((theme: Theme) => ({
  main: {
    padding: '0 8px',
    paddingRight: ({ pr }: SearchProps) => pr,
    paddingLeft: ({ pl }: SearchProps) => pl,
  },
  input: {
    width: ({ width }: SearchProps) => width || 335,
    height: 40,
    color: '#FFFFFF',
    padding: '10px 14px',
    fontSize: 14,
    '&::placeholder': {
      color: 'red',
    },
    '& .MuiOutlinedInput-input:-webkit-autofill': {
      '-webkit-box-shadow': 'none',
    },
    '& :-webkit-autofill': {
      transition: 'background-color 5000s ease-in-out 0s',
      '-webkit-background-clip': 'text',
    },
  },
  icon: {
    opacity: 0.6,
    color: theme.palette.primary.light,
    fontSize: 20,
  },
}))

const CssTextField = withStyles({
  root: {
    '& .MuiOutlinedInput-input': {
      opacity: 1,
    },
  },
})(TextField)

interface SearchProps {
  pr?: number | string
  pl?: number | string
  inputName: string
  className?: string
  width?: number | string
}

export const Search: FC<SearchProps> = ({ pr, pl, inputName, className, width }) => {
  const classes = useStyle({ pr, pl, inputName, width })

  const { register, setValue } = useFormContext()

  const handleChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(inputName, event.target.value)
    // eslint-disable-next-line
  }, [])

  return (
    <Grid item className={clsx(classes.main, className)}>
      <CssTextField
        {...register(inputName)}
        id={inputName}
        variant="outlined"
        placeholder="Search"
        onChange={handleChange}
        // value={value}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <span className={clsx(classes.icon, 'material-icons')}>{icons.SEARCH}</span>
            </InputAdornment>
          ),
          className: classes.input,
        }}
      />
    </Grid>
  )
}
